const V2Day1Part5StartingDialog = {
    startDialogId: 'op5_1',
    nodes: {
        op5_1: {
            id: 'op5_1',
            speaker: '',
            text: `???`,
            // characterImage: '/assets/character/v2/darius.png',
            backgroundImage: '/assets/backdrop/kamar_yan.png',
            nextDialogId: 'part1_2',
            sfx : "chicken",
        },
        part1_2: {
            id: 'part1_2',
            speaker: 'Yan',
            text: `Sudah saatnya bangun`,
            characterImage: '/assets/character/v2/yanf.png',
            backgroundImage: '/assets/backdrop/kamar_yan.png',
            nextDialogId: 'part1_3',
        },
        part1_3: {
            id: 'part1_2',
            speaker: 'Yan',
            text: `Coba kita lihat apakah Elsa dan Diana sudah bangun`,
            characterImage: '/assets/character/v2/yanf.png',
            backgroundImage: '/assets/backdrop/ruang_tamu.png',
            nextDialogId: 'part1_4',
            sfx : "openDoor"
        },
        part1_4: {
            id: 'part1_4',
            speaker: '',
            text: ``,
            characterImage: '/assets/character/v2/yanf.png',
            backgroundImage: '/assets/backdrop/ruang_tamu.png',
            nextDialogId: 'part1_5',
        },
        part1_5: {
            id: 'part1_4',
            speaker: '',
            text: ``,
            backgroundImage: '/assets/backdrop/ruang_tamu.png',
            nextDialogId: 'part1_6',
            sfx : "doorKnock"
        },
        part1_6: {
            id: 'part1_4',
            speaker: 'Yan',
            text: `Tidak ada respon. Apa yang sebaiknya aku lakukan?`,
            characterImage: '/assets/character/v2/yanf.png',
            backgroundImage: '/assets/backdrop/ruang_tamu.png',
            nextDialogId: 'part1_7',
        },
        part1_7: {
            id: 'part1_4',
            speaker: 'Yan',
            text: ``,
            characterImage: '/assets/character/v2/yanf.png',
            backgroundImage: '/assets/cutscene/black.png',
            choices: [
                {
                    text: 'Biarkan mereka beristirahat',
                    nextDialogId: 'part1_a1',
                },
                {
                    text: 'Jangan ganggu mereka',
                    nextDialogId: 'part1_a1',
                },
            ],
        },
        part1_a1: {
            id: 'part1_4',
            speaker: 'Yan',
            text: `Sepertinya mereka masih tidur, mari kita lihat ada apa diluar`,
            characterImage: '/assets/character/v2/yanf.png',
            backgroundImage: '/assets/backdrop/ruang_tamu.png',
            isEnd : true,
        },
        part1_b1: {
            id: 'part1_4',
            speaker: '',
            text: ``,
            backgroundImage: '/assets/cutscene/black.png',
            nextDialogId: 'part1_b2',
            sfx : "openDoor"
        },
        part1_b2: {
            id: 'part1_4',
            speaker: '',
            text: `...`,
            backgroundImage: '/assets/cutscene/black.png',
            characterImage: '/assets/character/v2/yanf.png',
            nextDialogId: 'part1_b3',
        },
        part1_b3: {
            id: 'part1_4',
            speaker: '',
            text: ``,
            backgroundImage: '/assets/cutscene/death_diana.jpg',
            nextDialogId: 'part1_b4',
            sfx : 'orchestraFreak'
        },
        part1_b4: {
            id: 'part1_4',
            speaker: 'Yan',
            text: `Apa yang harus aku lakukan`,
            backgroundImage: '/assets/cutscene/death_diana.jpg',
            choices: [
                {
                    text: 'Teriak meminta tolong',
                    nextDialogId: 'part1_c1',
                },
                {
                    text: 'Tenang dan investigasi',
                    nextDialogId: 'part1_d1',
                },
            ],
        },
        part1_c1: {
            id: 'part1_4',
            speaker: 'Yan',
            text: `Tolong!!!!`,
            backgroundImage: '/assets/cutscene/death_diana.jpg',
            characterImage: '/assets/character/v2/yanf.png',
            nextDialogId: 'part1_c2',
        },
        part1_c2: {
            id: 'part1_4',
            speaker: 'Yan',
            text: `Tolong!!!!`,
            backgroundImage: '/assets/cutscene/death_diana.jpg',
            characterImage: '/assets/character/v2/yanf.png',
            nextDialogId: 'part1_c3',
        },
        part1_c3: {
            id: 'part1_4',
            speaker: '',
            text: `Sepertinya tidak ada respons.`,
            backgroundImage: '/assets/cutscene/death_diana.jpg',
            characterImage: '/assets/character/v2/yanf.png',
            nextDialogId: 'part1_c4',
        },
        part1_c4: {
            id: 'part1_4',
            speaker: '',
            text: `Mungkin saatnya tenang dan coba kita analisa situasi ini`,
            backgroundImage: '/assets/cutscene/death_diana.jpg',
            characterImage: '/assets/character/v2/yanf.png',
            nextDialogId: 'part1_d1',
        },
        part1_d1: {
            id: 'part1_4',
            speaker: '',
            text: `Bagian apa yang ingin di investigasi`,
            backgroundImage: '/assets/cutscene/death_diana.jpg',
            choices: [
                {
                    text: 'Tumpahan Darah',
                    nextDialogId: 'part1_e1',
                },
                {
                    text: 'Kondisi badan Diana',
                    nextDialogId: 'part1_f1',
                },
                {
                    text: 'Selesai investigasi',
                    nextDialogId: 'part1_g1',
                },
            ],
        },
        part1_e1: {
            id: 'part1_e1',
            speaker: '',
            text: `Darah masih mengalir dan menetes ke lantai`,
            backgroundImage: '/assets/cutscene/death_diana_blood_zoom.png',
            nextDialogId: 'part1_e2',
        },
        part1_e2: {
            id: 'part1_e1',
            speaker: '',
            text: `Sepertinya darah masih baru, belum ada darah yang kering`,
            backgroundImage: '/assets/cutscene/death_diana_blood_zoom.png',
            nextDialogId: 'part1_d1',
        },
        part1_f1: {
            id: 'part1_f1',
            speaker: '',
            text: `Kondisi badan kering, serupa dengan kematian Sondakh`,
            backgroundImage: '/assets/cutscene/death_diana.jpg',
            nextDialogId: 'part1_d1',
        },
        part1_g1: {
            id: 'part1_g1',
            speaker: 'Yan',
            text: `Sebaiknya aku keluar dan mencari yang lain, terutama Elsa`,
            backgroundImage: '/assets/cutscene/death_diana.jpg',
            nextDialogId: 'part1_d1',
            isEnd : true
        },
    },
}

export default V2Day1Part5StartingDialog